import React from 'react';

import { Accordion, Flex, Title, useMantineTheme } from '@mantine/core';
import { DroxyBoxedIcon } from 'components/Droxy/DroxyBoxedIcon';

interface DroxyAccordionSectionProps {
  title: string;
  section: string;
  children: React.ReactNode;
  icon: React.ReactNode;
  hasError: boolean;
}

export function DroxyAccordionSection({ title, section, children, icon, hasError }: DroxyAccordionSectionProps) {
  const theme = useMantineTheme();

  return (
    <Accordion.Item
      value={section}
      sx={{
        borderColor: hasError ? theme.colors.red[3] : undefined
      }}>
      <Accordion.Control sx={{ backgroundColor: hasError ? theme.fn.rgba(theme.colors.red[0], 0.3) : undefined }}>
        <Flex align="center" gap="sm">
          <DroxyBoxedIcon icon={icon} isCircular size={24} hasBorder />
          <Title order={5} fw={500} size="sm" c={hasError ? 'red.7' : undefined}>
            {title}
          </Title>
        </Flex>
      </Accordion.Control>
      <Accordion.Panel>{children}</Accordion.Panel>
    </Accordion.Item>
  );
}
